// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"94bdad7017c5bc4fabe0","961":"6dc4d15e08f8952af0dc","2648":"dbcc4b0d777f7ba16ccd","6540":"4d4573cde88377b3ab99"}[chunkId] + ".js";
};